import styled from 'styled-components'

const ProfileStyle = styled.div.attrs()`
	.big-block {
		background-color: #fff8f2;
		padding: var(--sp5x) var(--containerPadding);
		width: 100%;

		.spacing {
			max-width: var(--sp41x);
			width: 100%;
			margin-left: var(--sp8x);
		}

		.info {
			flex: 1;
			margin-left: var(--sp9x);

			.single-menu-item {
				margin-right: var(--sp5x);

				&:nth-child(1),
				&:nth-child(2) {
					&:hover {
						.key {
							color: var(--black);
						}
					}
				}

				.key {
					color: #bcb5b0;
					transition: 0.3s;
					margin-left: var(--spSize);
				}
			}
		}
	}

	.profileCont {
		.profilePageCont {
			width: 100%;
			margin-bottom: var(--sp10x);

			.left {
				margin-top: calc(-1 * var(--sp8x));
				max-width: var(--sp41x);
				width: 100%;
				align-items: center;
				margin-left: var(--sp8x);

				.profile-pic {
					width: var(--sp31x);
					padding-top: var(--sp31x);
					margin-bottom: var(--sp3x);
					border-radius: 20px;
					overflow: hidden;
				}

				.personal-info {
					align-items: center;

					.edit-follow button,.follow {
						padding:var(--sp2x) var(--sp8x);
					}
					

					.name {
						font-size: var(--sp3x);
						text-align:center;
					}

					.place {
						margin: var(--sp1x) 0 var(--sp2x);
					}

					.job-info {
                        align-items:center ;
						margin-bottom: var(--sp2x);

						i {
							margin-right: var(--spSize);

							&:before {
								font-size: 14px;
							}
						}

						.at {
							margin: 0 var(--sp1x);
						}
					}

					.education-info {
						margin-bottom: var(--sp2x);

						i {
							margin-right: var(--spSize);

							&:before {
								font-size: 20px;
							}
						}

						.at {
							margin: 0 var(--sp1x);
						}
					}

					.socials {
						margin-bottom: var(--sp4x);

						a {
							margin: 0 10px;

							i {
								font-size: 20px;
							}
						}
					}
				}
			}

			.right {
				margin-top: var(--sp7x);
				flex: 1;
				margin-left: var(--sp9x);

			
				.single-block {
					margin-bottom: var(--sp5x);

					.btn-block {
						margin-top: var(--sp3x);
						flex-wrap: wrap;

						&.skills-block {
							& > div {
								background-color: transparent;
								border: 1px solid var(--lightGrey);

								&:hover {
									border-color:var(--purple);
								}
							}
						}

						& > div {
							margin-bottom: var(--spSize);
							margin-right: var(--spSize);
						}
					}
				}

				.debate-section {
					position: relative;

					.filters {
						top: 12px;
						right: 0;

					}

					.ant-tabs {
						.ant-tabs-nav {
							margin: 0;

							&:before {
								display: none;
							}

							.ant-tabs-nav-operations {
								display: none;
							}

							.ant-tabs-nav-wrap {
								.ant-tabs-nav-list {
									.ant-tabs-ink-bar {
										display: none;
									}

									.ant-tabs-tab {
										&.disabled {
											pointer-events:none;
											opacity:0.4;
										}
							
										.ant-tabs-tab-btn {
											font-family: PopReg;
											color: var(--black);
											font-size: var(--h9);
										}

										&-active {
											.ant-tabs-tab-btn {
												font-family: PopSemi;
												color: var(--purple);
												padding-left: var(--sp2x);

												&:before {
													content: '';
													position: absolute;
													top: 50%;
													left: 0;
													background-color: var(--purple);
													border-radius: 50%;
													width: 6px;
													height: 6px;
													transform: translateY(-50%);
												}
											}
										}
									}
								}
							}
						}

						.ant-tabs-content-holder {
							margin-bottom: var(--sp10x);

							.ant-tabs-tabpane {
								display: flex;
								flex-wrap: wrap;

								.single-debate-window {
									width: calc(50% - var(--sp2x));
									margin-top: var(--sp4x);

									&:nth-child(2n-1) {
										margin-right: var(--sp2x);
									}

									&:nth-child(2n) {
										margin-left: var(--sp2x);
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width:1390px) {
		.big-block {
			.info {
				margin-left: 0;
			}
		}
		
		.profileCont {
			.profilePageCont {
				.left {
					margin-left: 0;
				}

				.right {
					margin-top: var(--sp5x);
					margin-left: var(--sp5x);
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.big-block {
			.info {
				margin-left: 0;
			}
		}
		
		.profileCont {
			.profilePageCont {
				flex-direction: column;
				.left {
					margin-left: 0;
				}

				.right {
					margin-top: var(--sp5x);
					margin-left: 0;
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
		.profileMenuCont {
			position: absolute;
			width: calc(100% - var(--sp4x));
			left: var(--sp2x);
			border-radius: 20px;
			overflow: hidden;
			top: 100vw;
		}

		.big-block {
			padding: var(--sp2-5x) var(--containerPadding);

			.spacing {
				display: none;
			}

			.info {
				flex: 1;
				margin-left: 0;
				justify-content: center;

				.single-menu-item {
					margin-right: var(--sp1-25x);
					margin-left: var(--sp1-25x);
					flex-direction: row-reverse;
					align-items:center;
					i {
						font-size: var(--sp2-5x);
						margin-right: var(--spSize);
					}

					.value {
						font-size:10px;
						font-family:PopReg;
					}
				}
			}
		}

		.profileCont {
			.profilePageCont {
				flex-direction: column;

				.left {
					margin-top: var(--sp4x);
					max-width: unset;
					margin-left: 0;

					.profile-pic {
						width: 71.5%;
						padding-top: 71.5%;
					}

					.personal-info {
						.place {
							margin: var(--sp1x) 0 var(--sp2x);
						}

						.job-info {
							margin-top: var(--sp10x);
							margin-bottom: var(--sp2x);
							
							&.guest-profile {
								margin-top: var(--sp14x);
							}

							i {
								margin-right: var(--spSize);

								&:before {
									font-size: var(--h8);
								}
							}

							.at {
								margin: 0 var(--sp1x);
							}
						}

						.education-info {
							margin-bottom: var(--sp2x);

							i {
								margin-right: var(--spSize);

								&:before {
									font-size: 20px;
								}
							}

							.at {
								margin: 0 var(--sp1x);
							}
						}

						.socials {
						}
					}
				}

				.right {
					margin-top: var(--sp4x);
					flex: 1;
					margin-left: 0;

					.single-block {
						margin-bottom: var(--sp3x);

						.btn-block {
							margin-top: var(--sp3x);
						}
					}

					.debate-section {
						display: flex;
						flex-direction:column-reverse;

						.ant-tabs {
							margin-top:var(--spSize);

							.ant-tabs-content-holder {

								.ant-tabs-tabpane {

									.single-debate-window {
										width: 100%;
										margin-top: var(--sp3x);

										&:nth-child(2n-1) {
											margin-right: var(--sp0x);
										}

										&:nth-child(2n) {
											margin-left: var(--sp0x);
										}
									}
								}
							}
						}

						.filters {
							position: relative;
							align-self:flex-end;
							top:0;
						}
					}
				}
			}
		}
	}
`

export default ProfileStyle
